<template>
  <div class="rc-image-design">
    <label class="rc-image-label">{{initComponent.name}}</label>
    <div class="rc-image-show">
      <el-carousel ref="rcImageCarousel" :autoplay="false" :arrow="showArrow" height="200px">
        <el-carousel-item v-for="(item, index) in imageList" :key="item.src" :name="index.toString()">
          <img :src="hasImage? ossDownloadUrl + item.src : item.src"/>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import { componentMixin } from '../mixins'
export default {
  name: 'rc-image',
  props: ['initComponent'],
  mixins: [componentMixin],
  data () {
    let ossDownloadUrl = sessionStorage.getItem('ossDownloadUrl') || ''
    return {
      component: this.initComponent,
      ossDownloadUrl: ossDownloadUrl
    }
  },
  watch: {
    imageList () {
      // 设计页, 图片始终展示第一张
      this.$nextTick(() => {
        this.$refs.rcImageCarousel && this.$refs.rcImageCarousel.setActiveItem('0')
      })
    }
  },
  computed: {
    // 是否有图片了
    hasImage () {
      if (this.component.properties.imageList.filter(item => item.src).length !== 0) {
        return true
      } else {
        return false
      }
    },
    // 图片列表
    imageList () {
      let imageList = this.component.properties.imageList.filter(item => item.src)
      if (imageList.length === 0) {
        return [{src: require('../../design/assets/rc-image-empty.png')}]
      } else {
        return imageList
      }
    },
    // 是否展示左右箭头
    showArrow () {
      if (this.imageList.length <= 1) {
        return 'never'
      } else {
        return 'always'
      }
    }
  }
}
</script>

<style lang="scss">
.rc-image-design {
  .rc-image-label{
    display: block;
    width: 100px;
    padding-right: 12px;
    margin-bottom: 10px;
    color: #181818;
    font-size: 14px;
    line-height: 28px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .rc-image-show{
    .el-carousel {
      .el-carousel__container{
        .el-carousel__item{
          text-align: center;
          img{
            max-width: 100%;
            max-height: 100%;
          }
        }

      }
      .el-carousel__indicators{
        .el-carousel__indicator{
          display: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/components/image/rc-image.vue